/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';


export interface ResourceDemand { 
    id?: number;
    cnpj?: string;
    resource?: Array<ResourceDemand.ResourceEnum>;
    address?: Address;
    availability?: Array<number>;
    creationDate?: string;
    publicationDate?: string;
    expirationPublicationDate?: string;
    description?: string;
    status?: ResourceDemand.StatusEnum;
}
export namespace ResourceDemand {
    export type ResourceEnum = 'EXAME_LABORATORIAIS' | 'ECOGRAFIA' | 'TOMOGRAFIA' | 'RESSONANCIA_MAGNETICA' | 'RAIO_X' | 'MAMOGRAFIA' | 'ELETROCARDIOGRAMA_REPOUSO' | 'ELETROENCEFALOGRAMA' | 'ESPIROMETRIA' | 'VIDEO_NASOFIBROSCOPIA' | 'VIDEO_ENDOSCOPIA_NASOSSINUSAL' | 'MAPA' | 'TESTE_ERGOMETRICO' | 'ENDOSCOPIA_COLONOSCOPIA' | 'POLISSONOGRAFIA' | 'AUDIOMETRIAS' | 'CINTILOGRAFIA' | 'GENETICA' | 'ANATOMOPATOLOGICO' | 'PET_SCAN' | 'QUIMIOTERAPIA' | 'HEMODIALISE' | 'RADIOTERAPIA';
    export const ResourceEnum = {
        ExameLaboratoriais: 'EXAME_LABORATORIAIS' as ResourceEnum,
        Ecografia: 'ECOGRAFIA' as ResourceEnum,
        Tomografia: 'TOMOGRAFIA' as ResourceEnum,
        RessonanciaMagnetica: 'RESSONANCIA_MAGNETICA' as ResourceEnum,
        RaioX: 'RAIO_X' as ResourceEnum,
        Mamografia: 'MAMOGRAFIA' as ResourceEnum,
        EletrocardiogramaRepouso: 'ELETROCARDIOGRAMA_REPOUSO' as ResourceEnum,
        Eletroencefalograma: 'ELETROENCEFALOGRAMA' as ResourceEnum,
        Espirometria: 'ESPIROMETRIA' as ResourceEnum,
        VideoNasofibroscopia: 'VIDEO_NASOFIBROSCOPIA' as ResourceEnum,
        VideoEndoscopiaNasossinusal: 'VIDEO_ENDOSCOPIA_NASOSSINUSAL' as ResourceEnum,
        Mapa: 'MAPA' as ResourceEnum,
        TesteErgometrico: 'TESTE_ERGOMETRICO' as ResourceEnum,
        EndoscopiaColonoscopia: 'ENDOSCOPIA_COLONOSCOPIA' as ResourceEnum,
        Polissonografia: 'POLISSONOGRAFIA' as ResourceEnum,
        Audiometrias: 'AUDIOMETRIAS' as ResourceEnum,
        Cintilografia: 'CINTILOGRAFIA' as ResourceEnum,
        Genetica: 'GENETICA' as ResourceEnum,
        Anatomopatologico: 'ANATOMOPATOLOGICO' as ResourceEnum,
        PetScan: 'PET_SCAN' as ResourceEnum,
        Quimioterapia: 'QUIMIOTERAPIA' as ResourceEnum,
        Hemodialise: 'HEMODIALISE' as ResourceEnum,
        Radioterapia: 'RADIOTERAPIA' as ResourceEnum
    };
    export type StatusEnum = 'DRAFT' | 'OPEN' | 'CLOSE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Open: 'OPEN' as StatusEnum,
        Close: 'CLOSE' as StatusEnum
    };
}


